import { translations } from "i18n";
import React, { useState, useRef } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";

import Button from "containers/SettingsPages/components/Button";
import * as ConnectionState from "lib/devices/wrappers/DeviceStates";

import styles from "./style.module.scss";
import { MODAL_STYLES } from "data/constants";
import btnStyles from "components/Button/style.module.scss";
import { useConnectedDevices } from "hooks/ConnectedDevicesHook";

const MAX_NAME_LENGTH = 16;

const RenameDeviceModal = ({
  device,
  connectionState,
  isModalVisible,
  setIsModalVisible,
}) => {
  const [name, setName] = useState("");
  const refNameField = useRef();
  const { editDeviceName } = useConnectedDevices();

  const afterOpenModal = () => {
    setName("");
    refNameField.current.focus();
  };
  const closeModal = () => {};

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (!name.trim().length) {
      toast.warning(translations("RenameDeviceModal.CannotBeEmpty"));
      return;
    }
    if (!/^[a-zA-Z0-9 !@#$%^&*()-_=+`~]*$/.test(name.trim())) {
      toast.warning(
        translations("RenameDeviceModal.NameContainsUnsupportedCharacters")
      );
      return;
    }
    if (name.trim().length > 15) {
      toast.warning(translations("RenameDeviceModal.NameIsTooLong"));
      return;
    }
    if (connectionState === ConnectionState.CONNECTED) {
      try {
        await device?.wrapper?.setDeviceName(name);
        toast.success(translations("RenameDeviceModal.NewDeviceNameIsSet"));
        await editDeviceName(device, name);
      } catch (e) {
        toast.error(translations("RenameDeviceModal.ErrorHappened"));
      }
    }

    setIsModalVisible(false);
  };

  return (
    <Modal
      isOpen={isModalVisible}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={MODAL_STYLES}
    >
      <div className={styles.container}>
        <form onSubmit={handleSubmit}>
          <h1>{translations("RenameDeviceModal.RenameYourToy")}</h1>
          <div className={styles.settingsName}>
            {translations("AddSettingsModal.ToyName")}
          </div>
          <div
            className={styles.close}
            onClick={() => {
              setIsModalVisible(false);
            }}
          >
            +
          </div>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            ref={refNameField}
            maxLength={MAX_NAME_LENGTH}
          />
          <div className={styles.nameSize}>
            [{name.length}/{MAX_NAME_LENGTH}]
          </div>
          <div className={styles.buttonsWrapper}>
            <Button
              classnames={[styles.cancelButton, btnStyles.outline]}
              onClick={() => {
                setIsModalVisible(false);
              }}
              text={translations("General.Cancel")}
            />
            <Button
              classnames={[styles.saveButton, btnStyles.primary]}
              onClick={handleSubmit}
              text={translations("General.Save")}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default RenameDeviceModal;
